var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as querystring from 'querystring';
import { Configs } from "./constants";
import * as authorization from "../lib/authorization";
export function get(url, data) {
    // if (!data || !data.id)
    //     data.PageSize = data.PageSize || Configs.pageSize;
    var myInit = { method: 'GET' };
    var q = querystring.stringify(data);
    if (q)
        q = '&' + q;
    url = url + '?' + new Date().getTime();
    var myRequest = initRequest(url + q, myInit);
    return myfetch(myRequest);
    // q && (q = '?' + q)
    // var myRequest = initRequest(url + q, myInit);
    // if (options && options.noAuthorization) (myInit.headers as Headers).delete("Authorization")
    // return myfetch(myRequest);
}
export function post(url, data) {
    var myInit = { method: 'POST', body: null };
    signData(data);
    if (data instanceof FormData)
        myInit.body = data;
    else
        myInit.body = JSON.stringify(data);
    var myRequest = initRequest(url, myInit);
    return myfetch(myRequest);
}
export function put(url, data) {
    var myInit = {
        method: 'PUT', body: JSON.stringify(data),
    };
    var myRequest = initRequest(url, myInit);
    return myfetch(myRequest);
}
export function deleteIt(url, data) {
    var myInit = {
        method: 'DELETE', body: JSON.stringify(data)
    };
    var myRequest = initRequest(url, myInit);
    return myfetch(myRequest);
}
function myfetch(myRequest) {
    var _this = this;
    var done = false;
    setTimeout(function () {
        if (done == false) {
            window.loadingBox.show();
        }
    }, 150);
    return fetch(myRequest).then(function (d) { return __awaiter(_this, void 0, void 0, function () {
        var msg, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    done = true;
                    window.loadingBox.hide();
                    if (!!d.ok) return [3 /*break*/, 2];
                    return [4 /*yield*/, d.text()];
                case 1:
                    msg = _a.sent();
                    throw msg;
                case 2: return [4 /*yield*/, d.json()];
                case 3:
                    res = _a.sent();
                    if (!(parseInt(res.status) === 1)) return [3 /*break*/, 5];
                    return [4 /*yield*/, window.popBox.show(res.message).then(function () {
                            authorization.signOut();
                        })];
                case 4:
                    _a.sent();
                    throw { handled: true };
                case 5:
                    if (res.status !== "0" && res.status !== 0)
                        throw res;
                    return [2 /*return*/, res];
            }
        });
    }); }).catch(function (err) {
        done = true;
        window.loadingBox.hide();
        throw err;
    });
}
function initRequest(url, myInit) {
    setHeaders(myInit);
    if (!url.startsWith("http"))
        url = Configs.serviceUrl + url;
    var myRequest = new Request(url, myInit);
    return myRequest;
}
function setHeaders(myInit) {
    var myHeaders = new Headers();
    if (authorization.getAccessToken())
        myHeaders.append("Authorization", "Bearer " + authorization.getAccessToken());
    if (myInit.method !== "GET" && !(myInit.body instanceof FormData))
        myHeaders.append("Content-Type", "application/json; charset=utf-8");
    myInit.headers = myHeaders;
}
function signData(data) {
    return;
    // let userId = authorization.getUserId();
    // let token = authorization.getAccessToken();
    // let sign = md5(`userId=${userId}&token=${token}`);
    // if (data instanceof FormData) {
    //     (<FormData>data).append("sign", sign);
    //     (<FormData>data).append("userId", userId);
    // }
    // else {
    //    // data.userId = userId;
    //     data.sign = sign;
    // }
}
